var r;(r=>{r.primary='primary',r.secondary='secondary',r.neutral='neutral',r.white='white',r.success='success',r.warning='warning',r.danger='danger',r.info='info'})(r||(r={}));export{r as Variant};
